import { Box, Typography } from '@mui/material'
import React from 'react'

const CSConclusion = () => {
  return (
    <Box sx={{
                margin:{xs:"2rem 2rem 0rem 2rem ",sm:"4rem 4rem 0rem 4rem"},

    }}>
      <Typography sx={{
        fontFamily:"Plus Jakarta Sans",
        fontWeight:"500",
        fontSize:"1.8rem",
        marginTop:"1rem",

      }} >Conclusion</Typography>
      <Typography sx={{
                fontFamily:"Plus Jakarta Sans",
                marginTop:"1rem",

                color:"rgba(51, 51, 51, 1)",

      }} >Lorem ipsum dolor sit amet consectetur. Eu semper libero posuere turpis enim mauris est nec. Adipiscing ridiculus erat eleifend blandit faucibus nunc. Condimentum blandit arcu viverra rhoncus eu. Et et sed arcu nulla faucibus id lobortis.</Typography>
      <Typography sx={{
                fontFamily:"Plus Jakarta Sans",
                marginTop:"1rem",
                color:"rgba(51, 51, 51, 1)",

      }} >Lorem ipsum dolor sit amet consectetur. Eu semper libero posuere turpis enim mauris est nec. Adipiscing ridiculus erat eleifend blandit faucibus nunc. Condimentum blandit arcu viverra rhoncus eu. Et et sed arcu nulla faucibus id lobortis.</Typography>
    </Box>
  )
}

export default CSConclusion
